import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { InventorySearchItems, SystemComponentViewModel, ComponentHistoryViewModel, InventorySystems, ModelCreateInspection, ModelCreateInspectionResult, WSRECreateIdlerVM, ImageVM, UpdateInventoryCost } from './inventory-models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Tuple } from '../../entities';
@Injectable()
export class InventoryService {
  constructor(private _http: HttpClient) {
  }
  public searchSystemInInventory(searchParams: InventorySearchItems): Observable<InventorySystems> {
    //return this._http.post('api/Inventory/GetItemsInInventory', searchParams).pipe(catchError(this.handleError));
    return this._http.post<InventorySystems>('api/Inventory/GetInventory', searchParams).pipe(catchError(this.handleError));
  }

  public searchSystemInEquipment(searchParams: InventorySearchItems): Observable<InventorySystems> {
    return this._http.post<InventorySystems>('api/Inventory/GetItemsInEquipment', searchParams).pipe(catchError(this.handleError));
  }

  //TT-2355:
  public WSRECreateNewInspection(inspParams: ModelCreateInspection): Observable<ModelCreateInspectionResult> {
    return this._http.post<ModelCreateInspectionResult>('api/Inventory/WSRECreateNewInspection', inspParams).pipe(catchError(this.handleError));
  }

  public getSystemComponentsInfo(systemId): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
    };
    return this._http.get<SystemComponentViewModel[]>('api/Inventory/GetSystemComponentsInfoAsync', options).pipe(catchError(this.handleError));
  }

  public UpdateInventorySerial(model): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams()
        .set('systemId', model.moduleSubAuto)
        .set('serialName', model.serialNumber)
    };
    return this._http.get<SystemComponentViewModel[]>('api/Inventory/UpdateInventorySerialAsync', options).pipe(catchError(this.handleError));
  }


  public getSystemAllActionHistories(systemId): Observable<ComponentHistoryViewModel[]> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
    };
    return this._http.get<ComponentHistoryViewModel[]>('api/Inventory/GetSystemActionHistories', options).pipe(catchError(this.handleError));
  }

  public getComponentInfoInInventoryImages(componentDetailId): Observable<ImageVM[]> {
    const options = {
      params: new HttpParams().set('ComponentDetailId', componentDetailId.toString())
    };
    var result = this._http.get<ImageVM[]>('api/Inventory/GetComponentInfoInInventoryImages', options).pipe(catchError(this.handleError));
    return result;
  }
  public updateComponentInfoInInventoryImages(image: ImageVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inventory/updateSystemInInventoryImage', image).pipe(catchError(this.handleError));
  }

  public updateSystemInInventoryInfo(componentDetail: SystemComponentViewModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inventory/ChangeComponentInfoInInventory', componentDetail).pipe(catchError(this.handleError));
  }
  public updateSystemInInventoryComment(id: number, comment: string): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inventory/updateSystemInInventoryComment?id=' + id + 'comment=' + comment, "").pipe(catchError(this.handleError));
  }
  public updateSystemInInventoryImage(image: ImageVM): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inventory/updateSystemInInventoryImage', image).pipe(catchError(this.handleError));
  }
  public deleteComponentInfoInInventoryImage(imageId: number, screenId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('ImageId', imageId.toString()).set('ScreenId', screenId.toString())
    };
    return this._http.delete<Tuple>('api/Inventory/DeleteSystemInInventoryImage', options).pipe(catchError(this.handleError));
  }

  public getWornPercentageCalculationMethod(compartId, toolId, reading, inspectionId, eqId): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString())
        .set('toolId', toolId != null ? toolId.toString() : '-1')
        .set('reading', reading.toString())
        .set('inspectionId', inspectionId.toString())
        .set('generalEqId', eqId.toString())
    };
    return this._http.get<Tuple>('api/Inventory/GetWornPercentage', options).pipe(catchError(this.handleError));
  }

  public updateSystemNotes(systemId: number, newNotes: string, screenId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
        .set('newNotes', newNotes)
        .set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>('api/Inventory/UpdateSystemNote', options).pipe(catchError(this.handleError));
  }

  public relocateSystemJobsite(systemId, jobsiteId) {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString())
        .set('jobsiteId', jobsiteId.toString())
    };
    return this._http.get('api/Inventory/RelocateSystem', options).pipe(catchError(this.handleError));
  }

  public GetIdlerListForSelectedModel(modelId): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    return this._http.get<SystemComponentViewModel[]>('api/WSRE/GetIdlerForSelectedModel', options).pipe(catchError(this.handleError));
  }

  public CeateFrameAndGEWForIdlerWSRE(compartId, Jobsiteid, makeid, modelid): Observable<WSRECreateIdlerVM> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString()).set('Jobsiteid', Jobsiteid.toString()).set('makeid', makeid.toString()).set('modelid', modelid.toString())
    };
    return this._http.get<WSRECreateIdlerVM>('api/WSRE/CeateFrameAndGEWForIdlerWSRE', options).pipe(catchError(this.handleError));
  }

  public GetFrameForSelectedModelLeft(modelId): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    return this._http.get<SystemComponentViewModel[]>('api/WSRE/GetFrameForSelectedModelLeft', options).pipe(catchError(this.handleError));
  }

  public GetFrameForSelectedModelRight(modelId): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams().set('modelId', modelId.toString())
    };
    return this._http.get<SystemComponentViewModel[]>('api/WSRE/GetFrameForSelectedModelRight', options).pipe(catchError(this.handleError));
  }

  public VerifyserilaNo(serialno): Observable<any> {
    const options = {
      params: new HttpParams().set('serialno', serialno.toString())
    };
    return this._http.get('api/WSRE/VerifyserilaNo', options).pipe(catchError(this.handleError));
  }

  public CeateFrameAndGEWForFrameWSRE(compartId, Jobsiteid, makeid, modelid, srialNo, side): Observable<WSRECreateIdlerVM> {
    const options = {
      params: new HttpParams().set('compartId', compartId.toString()).set('Jobsiteid', Jobsiteid.toString()).set('makeid', makeid.toString()).set('modelid', modelid.toString())
        .set('srialNo', srialNo.toString()).set('side', side.toString())
    };
    return this._http.get<WSRECreateIdlerVM>('api/WSRE/CeateFrameAndGEWForFrameWSRE', options).pipe(catchError(this.handleError));
  }

  public POSTCreateWSREInspectionFrame(inspParams: ModelCreateInspection): Observable<ModelCreateInspectionResult> {
    return this._http.post<ModelCreateInspectionResult>('api/Inventory/POSTCreateWSREInspectionFrame', inspParams).pipe(catchError(this.handleError));
  }

  public UpdateWsreStatus(wsreid: number, statusId: number, side: string, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('wsreid', wsreid.toString()).set('statusId', statusId.toString()).set('side', side.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<boolean>('api/Inventory/UpdateWsreStatus', options).pipe(catchError(this.handleError));
  } private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error || 'Server error');
  }

  public updateLUUCInventoryStatus(ModuleSubAuto: number, Id: Number, ScreenId: number): Observable<Tuple> {
    let model = { ModuleSubAuto: ModuleSubAuto, Id: Id, ScreenId: ScreenId }
    return this._http.post<Tuple>('api/Inventory/UpdateLUUCInventoryStatus', model).pipe(catchError(this.handleError));
  }

  public updateSideStatus(ModuleSubAuto: number, Id: Number): Observable<Tuple> {
    let model = { ModuleSubAuto: ModuleSubAuto, Id: Id }
    return this._http.post<Tuple>('api/Inventory/updateSideStatus', model).pipe(catchError(this.handleError));
  }

  public GetEquipmentRecordHistory(equipment_auto: number): Observable<SystemComponentViewModel[]> {
    const options = {
      params: new HttpParams().set('equnit_auto', equipment_auto.toString())
    };
    return this._http.get<SystemComponentViewModel[]>('api/Action/GetEquipmentRecordHistory', options).pipe(catchError(this.handleError));
  }
  public updateComponentCost(image: UpdateInventoryCost): Observable<Tuple> {
    return this._http.post<Tuple>('api/Inventory/UpdateComponentCost', image).pipe(catchError(this.handleError));
  }

}
